window.recurly = window.recurly || {};
window.google = window.google || {};

if (window.location.protocol !== 'https:') {
  console.log('Redirect to SSL');
  window.location = `https://${window.location.hostname}`;
}

console.log(`App Version: ${window.appVersion}`);

require('window.location');
require('../../../node_modules/lodash/lodash.min.js');
require("angular-bootstrap-contextmenu");

require('./appController');
require('./appKey');
require('./currentUser/currentUser');
require('./currentUser/authentication/constant');
require('./httpInterceptors');
require('./transformResource');
require('./ipAddressService');
require('./convertToNumberDirective');
require('./errSrcDirective');

require("../welcome/welcome");
require("../mainFrame/mainFrame");
require("./hostnameMatchService");
require("./stickyHeightDirective");
require("./doubleHorizontalScrollDirective");

"use strict";

angular.module('app', [
  'ui.bootstrap',
  'ui.router',
  'ngAnimate',
  'ngSanitize',
  'ngCookies',
  'ngInflection',
  'toggle-switch',
  'xeditable',
  'luegg.directives',
  'ui.bootstrap.contextMenu',
  'ui.sortable',

  'app.appController',
  'app.appKey',
  'app.currentUser',
  'app.currentUser.authentication.constant',
  'app.httpInterceptors',
  'app.transformResource',
  'app.constants',
  'app.ipAddressService',
  'app.convertToNumberDirective',
  'app.errSrcDirective',
  'app.hostnameMatchService',
  'app.stickyHeightDirective',
  'app.doubleHorizontalScrollDirective',
  'app.welcome',
  'app.mainFrame',
])
  .config([
    '$urlRouterProvider', '$compileProvider', '$locationProvider', '$qProvider',
    function ($urlRouterProvider, $compileProvider, $locationProvider, $qProvider) {
      $locationProvider.html5Mode(false).hashPrefix('');
      $qProvider.errorOnUnhandledRejections(false);

      $urlRouterProvider.otherwise('/');

      if (window.environmentConfig) {
        window.environmentConfig.onConfig($compileProvider);
      }
    }
  ])

  .run([
    '$rootScope',
    '$state',
    '$stateParams',
    '$window',
    '$location',
    'appKey',
    'currentUser',
    'RECURLY_API_KEY',
    'AUTHENTICATION',
    'app.ipAddressService',
    'editableOptions',
    'hostnameMatchService',
    '$interval',
    '$transitions',
    'PRODUCT',
    function ($rootScope, $state, $stateParams, $window, $location, appKey, currentUser,
      RECURLY_API_KEY, AUTHENTICATION, ipAddressService, editableOptions, hostnameMatch,
      $interval, $transitions, product) {

      function bootstrapApplication() {
        // Validate Authentication Routing
        $transitions.onStart({}, validateAuthenticationAndSubscription);

        $transitions.onStart({}, hideUI);

        // Add global goBack function to every state transition
        $transitions.onSuccess({}, addGoBackFn);

        let bootstrapTimer = $interval(() => {
          if ($state.current.name) {
            $rootScope.$applyAsync(() => {
              $rootScope.bootstrapped = true;
              $interval.cancel(bootstrapTimer);
              if ($state.includes('welcome') && currentUser.is_logged_in()) {
                $state.go('app.home');
              } else {
                $state.transitionTo($state.current, $stateParams, {
                  reload: true, inherit: false, notify: true
                });
              }
            });
          }
        }, 100, 0, false);
        $scope.$on('$destroy', () => {
          if (bootstrapTimer) {
            $interval.cancel(bootstrapTimer);
          }
        });
      }

      function validateStateNameBySite(stateName) {
        switch (product.Code) {
          case "ahl":
            for (let i in AUTHENTICATION.NON_AHL_STATES) {
              let regex = new RegExp('^' + AUTHENTICATION.NON_AHL_STATES[i]);
              if (stateName.match(regex)) {
                return currentUser.is_logged_in() ? { toStateName: 'app.schedule', changeState: false }
                  : { toStateName: 'app.welcome', changeState: false };
              }
            }
            return { toStateName: stateName, changeState: true };
          default:
            return { toStateName: stateName, changeState: true };
        }

      }

      function validateAuthenticationAndSubscription($transition) {
        let toState = $transition.$to();
        let logged = currentUser.is_logged_in();
        let requiresAuth = !_.includes(AUTHENTICATION.NON_AUTH_STATES, toState.name);
        let validStateBySite = validateStateNameBySite(toState.name);

        if (!validStateBySite.changeState) {
          if ($state.hasOwnProperty("current")) {
            $state.target(validStateBySite.toStateName);
          } else {
            $state.go(validStateBySite.toStateName);
          }

          return false;
        }

        if (!logged) {
          for (let i in AUTHENTICATION.NON_AUTH_TO_LOGIN) {
            let value = AUTHENTICATION.NON_AUTH_TO_LOGIN[i];
            let regex = new RegExp('^' + value);
            if (toState.name.match(regex)) {
              $state.go('app.login', { redirect: toState.name, redirectParams: toState.params }, { reload: true });
              return false;
            }
          }

          requiresAuth = true;
          for (let i in AUTHENTICATION.NON_AUTH_STATES) {
            let value = AUTHENTICATION.NON_AUTH_STATES[i];
            let regex = new RegExp('^' + value);
            if (toState.name.match(regex)) {
              requiresAuth = false;
              break;
            }
          }
          if (requiresAuth) {
            $state.go(AUTHENTICATION.DEFAULT_AUTH_STATE);
            return false;
          }
        }

        if (logged && !currentUser.data.is_admin && (toState.name === 'app.sessionTimeout' || toState.name === 'app.login')) {
          $state.go('app.home');
          return false;
        }

        return true;
      }

      function hideUI() {
        let hostname = hostnameMatch.hostname();
        if (hostname === 'localhost' || hostname === 'localhost.hockeytv.com') {
          return;
        }

        let protocol;

        if ($window.location.protocol !== 'https:') {
          protocol = 'https:';
        }

        $rootScope.hideUI = !!protocol;
      }

      function addGoBackFn($transition) {
        let to = $transition.$to();
        let from = $transition.$from();

        if (
          (to.name.match(/^app\.login$/) && from.name.match(/^app\.login$/))
          || (to.name.match(/^app\.mobileLogin$/) && from.name.match(/^app\.mobileLogin$/))
        ) {
          if (from.previous_state) {
            if (from.previous_state.name.match(/^app\.login$/)) {
              from.previous_state = null;
            }
            else {
              from = from.previous_state;
            }
          }
          else {
            from = null;
          }
        }

        $state.current.previous_state = from;
        $state.current.goBack = function (force) {
          let options = force ? { reload: true } : {};
          if (to.previous_state && to.previous_state.name) {
            if (
              to.previous_state.name.match(/^welcome/)
              || to.previous_state.name === 'app.locked'
              || to.previous_state.name === 'app.sessionTimeout'
              || to.previous_state.name === 'app.passwordReset.save'
              || to.previous_state.name === 'app.passwordReset.sent'
            ) {
              $state.go('app.home', {}, options);
            } else if (
              (to.name === "app.login" || to.name === "app.mobileLogin")
              && (to.previous_state.name === "app.registration.new" || to.previous_state.name === "app.registration")) {
              $state.go('app.home');
            } else if ((to.previous_state.name === "app.login" || to.previous_state.name === "app.mobileLogin")
              || to.previous_state.name === "app.registration.new"
              || to.previous_state.name === "app.registration"
              || to.previous_state.name === "app.registration.confirmation") {
              $state.go('app.home');
            } else {
              $state.go(to.previous_state.name, to.previous_state.params, options);
            }
          } else {
            $state.go('app.home');
          }
        };
      }

      $rootScope.hideUI = false;

      appKey.set_user_key_from_cookie();

      editableOptions.theme = 'bs3';

      try {
        window.recurly.configure(RECURLY_API_KEY);
      }
      catch (err) {
        console.log(err);
      }

      if (window.environmentConfig) {
        window.environmentConfig.onRun($window, $transitions, $location);
      }

      let stateChangeStart = () => {
        if (!$rootScope.bootstrapped) {
          ipAddressService.retrieve()
            .then(function () {
              // Check if the user was logged to bootstrap the App
              if (appKey.user_key) {
                return currentUser
                  .retrieve()
                  .then(
                    bootstrapApplication,
                    () => {
                      appKey.destroy();
                      $state.go('app.login').then(bootstrapApplication);
                    });
              } else {
                bootstrapApplication();
              }
            });
        }
      };

      $transitions.onStart({}, stateChangeStart);
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/fhApp/app.js